import { money, pct } from "@/lib/money"

/** Internal only — the base bid's margin against each level's mean-COGS
 *  blend. Never printed; the bid sheet carries zero cost keys. */
export function MarginCheckCard({
  check,
}: {
  check: { revenue: string; cost: string; gm_pct: string } | null
}) {
  if (!check) return null
  return (
    <section
      className="rounded-lg border border-dashed border-hairline p-4"
      data-testid="margin-check-card"
    >
      <h2 className="flex items-center gap-2">
        Margin check <span className="text-sm font-normal text-ink-muted">internal only</span>
      </h2>
      <dl className="mt-3 grid grid-cols-[1fr_auto] gap-y-1.5 text-sm">
        <dt className="text-ink-muted">Base revenue</dt>
        <dd className="text-right tabular-nums">{money(check.revenue)}</dd>
        <dt className="text-ink-muted">Blended COGS</dt>
        <dd className="text-right tabular-nums">{money(check.cost)}</dd>
        <dt className="text-ink-muted">Blended GM</dt>
        <dd className="text-right tabular-nums font-medium" data-testid="margin-check-gm">
          {pct(check.gm_pct)}
        </dd>
      </dl>
    </section>
  )
}
